import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { AlertBar } from './components/AlertBar';
import { ProgressBar } from './components/ProgressBar';
import { TrustFooter } from './components/TrustFooter';
import { AgeStep } from './components/steps/AgeStep';
import { GoalStep } from './components/steps/GoalStep';
import { LocationStep } from './components/steps/LocationStep';
import { PersonalInfoStep } from './components/steps/PersonalInfoStep';
import { PhoneStep } from './components/steps/PhoneStep';
import { EmailStep } from './components/steps/EmailStep';
import { SuccessPage } from './components/steps/SuccessPage';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/pAUUzwkew5M2Jdo9P6J2GU/ChatGPT_Image_9_abr_2026,_04_58_39_p.m..png';
const STEPS = ['#edad', '#objetivo', '#ubicacion', '#datos', '#telefono', '#email', '#exito'];
export function App() {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [formData, setFormData] = useState({
    age: '',
    goal: '',
    state: '',
    firstName: '',
    lastName: '',
    phone: '',
    email: ''
  });
  // Handle hash-based routing
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash || '#edad';
      const index = STEPS.indexOf(hash);
      if (index !== -1) {
        setCurrentStepIndex(index);
      } else {
        // If invalid hash, redirect to first step
        window.location.hash = STEPS[0];
      }
    };
    // Initial check
    if (!window.location.hash) {
      window.location.hash = STEPS[0];
    } else {
      handleHashChange();
    }
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  const goToNextStep = (nextIndex: number) => {
    if (nextIndex < STEPS.length) {
      window.location.hash = STEPS[nextIndex];
    }
  };
  const updateFormData = (data: Partial<typeof formData>) => {
    setFormData(prev => ({
      ...prev,
      ...data
    }));
  };
  const isSuccessPage = currentStepIndex === STEPS.length - 1;
  return <div className="min-h-screen flex flex-col bg-light font-sans pt-8 sm:pt-9 pb-12 sm:pb-16" data-id="element-0">
      {!isSuccessPage && <AlertBar userState={formData.state || 'tu área'} data-id="element-1" />}
      {!isSuccessPage && <ProgressBar currentStep={currentStepIndex} totalSteps={STEPS.length - 1} data-id="element-2" />}

      <main className={`flex-1 flex flex-col items-center relative ${isSuccessPage ? 'justify-start overflow-auto' : 'justify-center overflow-hidden'}`} data-id="element-3">
        {/* Logo */}
        <div className={`flex justify-center ${isSuccessPage ? 'pt-2 mb-1' : 'mb-2'}`} data-id="element-4">
          <img src={LOGO_URL} alt="Life Freedom" className="h-24 sm:h-32 object-contain" data-id="element-5" />
        </div>

        <AnimatePresence mode="wait" data-id="element-6">
          <motion.div key={currentStepIndex} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -20
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="w-full" data-id="element-7">
            {currentStepIndex === 0 && <AgeStep defaultValue={formData.age} onNext={age => {
            updateFormData({
              age
            });
            goToNextStep(1);
          }} data-id="element-8" />}
            {currentStepIndex === 1 && <GoalStep defaultValue={formData.goal} onNext={goal => {
            updateFormData({
              goal
            });
            goToNextStep(2);
          }} data-id="element-9" />}
            {currentStepIndex === 2 && <LocationStep defaultValue={formData.state} onNext={state => {
            updateFormData({
              state
            });
            goToNextStep(3);
          }} data-id="element-10" />}
            {currentStepIndex === 3 && <PersonalInfoStep defaultFirstName={formData.firstName} defaultLastName={formData.lastName} onNext={({
            firstName,
            lastName
          }) => {
            updateFormData({
              firstName,
              lastName
            });
            goToNextStep(4);
          }} data-id="element-11" />}
            {currentStepIndex === 4 && <PhoneStep defaultValue={formData.phone} onNext={phone => {
            updateFormData({
              phone
            });
            goToNextStep(5);
          }} data-id="element-12" />}
            {currentStepIndex === 5 && <EmailStep defaultValue={formData.email} onNext={async email => {
            updateFormData({
              email
            });
            goToNextStep(6);
            const payload = {
              ...formData,
              email
            };
            try {
              await fetch('https://services.leadconnectorhq.com/hooks/1GwCc69xxIEbnVuzsYbO/webhook-trigger/0e3ee1df-5045-44c8-8215-63b330329404', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload),
                mode: 'no-cors'
              });
            } catch (err) {
              console.error('Webhook error:', err);
            }
          }} data-id="element-13" />}
            {currentStepIndex === 6 && <SuccessPage data-id="element-14" />}
          </motion.div>
        </AnimatePresence>
      </main>
      <TrustFooter data-id="element-15" />
    </div>;
}